import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useModalCTAContext } from '@providers/ModalCTAProvider';
import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';
import ROUTES from '@constants/routes';

const useStopSession = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { t: translate } = useTranslation();
  const { sendMessageToEvent } = useMytaverse();
  const { currentEvent } = useMytaverseEvent();
  const { setValuesForModal } = useModalCTAContext();
  const navigate = useNavigate();

  return useCallback(
    (isFamiliarization = false) => {
      setIsOpenModal((prevState) => !prevState);

      if (!currentEvent?.eventId) {
        return;
      }

      const closeModal = () => {
        setIsOpenModal(false);
      };

      if (isFamiliarization) {
        setTimeout(closeModal, 3000);
      }

      setValuesForModal({
        title: translate('trainerToolModal.stopSessionModal.title'),
        message: translate('trainerToolModal.stopSessionModal.message'),
        altStyling: true,
        onConfirm: () => {
          if (isFamiliarization) {
            closeModal();
          } else {
            sendMessageToEvent(currentEvent?.eventId as string, {
              action: WebsocketAction.StopEntireSession,
            });

            setTimeout(() => {
              navigate(ROUTES.SELECT_EVENT);
            }, 100);
          }
        },
        onCancel: closeModal,
        onClose: closeModal,
        open: !isOpenModal,
        confirmButtonName: translate(
          'trainerToolModal.stopSessionModal.confirmButton',
        ),
        cancelButtonName: translate(
          'trainerToolModal.stopSessionModal.cancelButton',
        ),
      });
    },
    [isOpenModal, currentEvent?.eventId],
  );
};

export default useStopSession;
